import { dateNow, monoNow } from "../../utils/date.js";
import { genShortID } from "../../utils/shortId.js";
import { stringifyObjectValues } from "../../utils/json.js";
import { Observable } from "../../utils/reactive.js";
import _objectSpread2 from "../../_virtual/_@oxc-project_runtime@0.150.0/helpers/esm/objectSpread2.js";
import "../../transports/const.js";
import { UserActionImportance, userActionEventName } from "./const.js";
import "./types.js";
import { ItemBuffer } from "../ItemBuffer.js";
//#region src/api/userActions/userAction.ts
var UserAction = class extends Observable {
	constructor({ name, parentId, trigger, transports, attributes, trackUserActionsExcludeItem, importance = UserActionImportance.Normal, pushEvent }) {
		super();
		this.name = name;
		this.attributes = attributes;
		this.id = genShortID();
		this.trigger = trigger;
		this.parentId = parentId !== null && parentId !== void 0 ? parentId : this.id;
		this.trackUserActionsExcludeItem = trackUserActionsExcludeItem;
		this.importance = importance;
		this._pushEvent = pushEvent;
		this._itemBuffer = new ItemBuffer();
		this._transports = transports;
		this._state = 0;
		this._start();
	}
	addItem(item) {
		if (this._state === 0) {
			this._itemBuffer.addItem(item);
			return true;
		}
		return false;
	}
	_start() {
		this._state = 0;
		if (this._state === 0) {
			this.startTime = dateNow();
			this._startTimeMono = monoNow();
		}
	}
	halt() {
		if (this._state !== 0) return;
		this._state = 1;
		this.notify(this._state);
	}
	cancel() {
		if (this._state === 0) this._itemBuffer.flushBuffer((item) => {
			this._transports.execute(item);
		});
		this._state = 2;
		this.notify(this._state);
	}
	end() {
		if (this._state === 2) return;
		const endTime = dateNow();
		const duration = monoNow() - this._startTimeMono;
		this._state = 3;
		this._itemBuffer.flushBuffer((item) => {
			if (isExcludeFromUserAction(item, this.trackUserActionsExcludeItem)) {
				this._transports.execute(item);
				return;
			}
			const userActionItem = _objectSpread2(_objectSpread2({}, item), {}, { payload: _objectSpread2(_objectSpread2({}, item.payload), {}, { action: {
				parentId: this.id,
				name: this.name
			} }) });
			this._transports.execute(userActionItem);
		});
		this._state = 3;
		this.notify(this._state);
		this._pushEvent(userActionEventName, _objectSpread2({
			userActionName: this.name,
			userActionStartTime: this.startTime.toString(),
			userActionEndTime: endTime.toString(),
			userActionDuration: duration.toString(),
			userActionTrigger: this.trigger,
			userActionImportance: this.importance
		}, stringifyObjectValues(this.attributes)), void 0, {
			timestampOverwriteMs: this.startTime,
			customPayloadTransformer: (payload) => {
				payload.action = {
					id: this.id,
					name: this.name
				};
				return payload;
			}
		});
	}
	getState() {
		return this._state;
	}
};
function isExcludeFromUserAction(item, trackUserActionsExcludeItem) {
	return (trackUserActionsExcludeItem === null || trackUserActionsExcludeItem === void 0 ? void 0 : trackUserActionsExcludeItem(item)) || item.type === "measurement" && item.payload.type === "web-vitals";
}
//#endregion
export { UserAction as default };

//# sourceMappingURL=userAction.js.map